import { get } from 'lodash';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import CustomError from '@/utils/custom-error';
import { fetchSiteKeys } from '@/services/RecaptchaService';

export const loadPlugin = (Vue, reCaptchaSiteKey) => Vue.use(VueReCaptcha, {
  siteKey: reCaptchaSiteKey,
  loaderOptions: {
    useRecaptchaNet: true,
    autoHideBadge: false,
    explicitRenderParameters: true,
    renderParameters: true,
  },
});

export default async (Vue) => {
  fetchSiteKeys().then((response) => {
    const { status, data } = response;
    if (status.statusCode === 200) {
      const reCaptchaSiteKey = get(data, 'reCaptcha.secretKeyData.value');
      loadPlugin(Vue, reCaptchaSiteKey);
    } else {
      throw new CustomError(data, data.details.message);
    }
  }).catch((error) => {
    throw new CustomError(error, error?.message);
  });
};
